import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ucProxy, { ucRestfulProxy } from './mixins/uc-proxy'
import { IS_PRODUCTION } from '@/common/variables'

Vue.config.productionTip = false
Vue.prototype.CDP = false
Vue.prototype.$ucProxy = ucProxy
Vue.prototype.$ucRestfulProxy = ucRestfulProxy
import 'ds-open-header/libs/ds-open-header.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

import DsViews from 'ds-views'
import 'ds-views/lib/ds-views.css'
Vue.use(DsViews)
import './less/index.less'

if (IS_PRODUCTION && window.collectEvent) {
  window.collectEvent('init', {
    app_id: 394858, // 参考2.1节获取，注意类型是number而非字符串
    channel: 'cn', // 设置数据上送地址
    log: false, // true:开启日志，false:关闭日志
    autotrack: false // 全埋点开关，true开启，false关闭
  })
  // 此处可添加设置uuid、设置公共属性等代码
  window.collectEvent('start') // 通知SDK设置完毕，可以真正开始发送事件了
}

// if (process.env.NODE_ENV === 'production') {
//   Sentry.init({
//     dsn: 'https://78038faf2ecb4447bb6373942bafb387@sentry.datastory.com.cn/2',
//     integrations: [new VueIntegration({ Vue, attachProps: true, logErrors: true })],
//     environment: location.hostname.includes('.dev.') ? 'test' : 'production'
//   })
// }

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
